// IMPORTS
// Assets
import './../scss/OHSConfirmation.scss';


// COMPONENT
export default function OHSConfirmation (props) {
   // Function
   const handleProceed = function () {
      if ((props.confirmation.proceed) && (props.confirmation.proceed !== null)) {
         props.confirmation.proceed();
      }
      closeConfirmation();
   }
   const closeConfirmation = function () {
      props.setConfirmation({
         display: false,
         message: null,
         proceed: null,
         yesno: false
      });
   }

   // Component
   return (
      <>
         {props.confirmation.display && 
            <div className='ohsconfirmation'>
               <div className='ohsconfirmation-content'>
                  <div className='ohsconfirmation-header'>
                     <p>Confirm</p>
                  </div>
                  <div className='ohsconfirmation-body'>
                     <p>{props.confirmation.message && props.confirmation.message.length > 0 ? props.confirmation.message : "Are you sure you wish to perform this action?"}</p>
                  </div>
                  <div className='ohsconfirmation-actions'>
                     <button className='ohsbtn-success' onClick={handleProceed}>{props.confirmation.yesno ? "Yes" : "Proceed"}</button>
                     <button className='ohsbtn-error' onClick={closeConfirmation}>{props.confirmation.yesno ? "No" : "Cancel"}</button>
                  </div>
               </div>
            </div>
         }
      </>
   );
}